export const TOKEN_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30; // 30 days
export const TOKEN_COOKIE_EXPIRES_DAYS = 30;

export function getTokenCookieBaseOptions() {
  const isProduction = window.location.hostname.endsWith("quizrr.in");
  return {
    path: "/",
    sameSite: "Lax",
    secure: true,
    ...(isProduction ? { domain: ".quizrr.in" } : {}),
  };
}

// For react-cookie's setCookie — maxAge in seconds
export function getReactCookieTokenOptions(overrides = {}) {
  return {
    ...getTokenCookieBaseOptions(),
    maxAge: TOKEN_COOKIE_MAX_AGE_SECONDS,
    ...overrides,
  };
}

// For js-cookie's Cookies.set — expires in days
export function getJsCookieTokenOptions(overrides = {}) {
  return {
    ...getTokenCookieBaseOptions(),
    expires: TOKEN_COOKIE_EXPIRES_DAYS,
    ...overrides,
  };
}
